import React from "react";
import * as Icon from "react-feather";

import "./quickbooks-refresh-modal.css";
import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import QuickBooksTrialBalancePanel from "./QuickBooksTrialBalancePanel";
import QuickBooksMovedAccounts from "./QuickBooksMovedAccounts";
import BookkeepingService from "../../../../services/BookkeepingService";
import UtilityService from "../../../../services/UtilityService";

class QuickBooksRefreshModal extends WComponent {
	state = { checking: true, changes: null, error: "", pullingAgain: false, saved: false };

	componentDidMount = async () => {
		await this.check();
	};

	check = async () => {
		const { clientId, wpfEngagementId } = this.props;
		await this.update({ checking: true, error: "" });
		const answer = await BookkeepingService.findQuickBooksChangesSincePull({ clientId, wpfEngagementId });
		await this.update({ checking: false, changes: answer.changes || null, error: answer.error || "" });
	};

	onPullAgain = () => this.update({ pullingAgain: true });

	onImported = async ({ importedTrialBalance }) => {
		await this.update({ saved: true });
		if (this.props.onRefreshed) await this.props.onRefreshed({ importedTrialBalance });
	};

	renderCheck = () => {
		const { checking, changes, error } = this.state;
		if (checking) return <p className="tk-lead">Reading QuickBooks again…</p>;
		if (error) return <div className="tk-notice tk-notice--danger"><p className="tk-notice__detail">{error}</p></div>;
		if (!changes) return <p className="tk-lead">These books did not come from QuickBooks.</p>;
		if (!changes.reachable) {
			return (
				<div className="tk-notice tk-notice--warning" data-test="qbo-refresh-unreachable">
					<p className="tk-notice__detail">QuickBooks could not be read, so whether anything moved is not known: {changes.unreachableBecause}</p>
				</div>
			);
		}
		if (!changes.hasMoved) {
			return (
				<p className="qbrefresh__unchanged" data-test="qbo-refresh-unchanged">
					<span className="tk-status-dot tk-status-dot--success" />
					Nothing has moved in QuickBooks since these books were pulled. Checked {UtilityService.formatDateTime({ value: changes.checkedAt })}.
				</p>
			);
		}
		return (
			<React.Fragment>
				<p className="tk-lead">
					{UtilityService.describeCount({ count: changes.moved.length, singular: "account" })} moved in QuickBooks since these books were pulled. Pull again
					to bring the statements up to date; nothing changes until you save the new pull.
				</p>
				<QuickBooksMovedAccounts moved={this.state.changes.moved} />
			</React.Fragment>
		);
	};

	renderFooter = () => {
		const { checking, changes, pullingAgain, saved } = this.state;
		const { onClose } = this.props;
		if (pullingAgain || saved) return <span className="tk-modal-actions"><button type="button" className="tk-button tk-button--secondary" onClick={onClose}>{saved ? "Done" : "Close"}</button></span>;
		const somethingMoved = !!(changes && changes.hasMoved);
		return (
			<span className="tk-modal-actions">
				<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Close</button>
				<button type="button" className={somethingMoved ? "tk-button tk-button--primary" : "tk-button tk-button--secondary"} data-test="qbo-refresh-pull-again" onClick={this.onPullAgain} disabled={checking}>
					<Icon.RefreshCw size={13} /> Pull again
				</button>
			</span>
		);
	};

	render() {
		const { clientId, wpfEngagementId, onClose } = this.props;
		const { pullingAgain } = this.state;
		return (
			<ToolsModal open onClose={onClose} title="Refresh from QuickBooks" width={pullingAgain ? 900 : 640} footer={this.renderFooter()}>
				<div className="qbrefresh" data-test="qbo-refresh">
					{pullingAgain ? (
						<QuickBooksTrialBalancePanel clientId={clientId} wpfEngagementId={wpfEngagementId} startByPulling onImported={this.onImported} />
					) : (
						this.renderCheck()
					)}
				</div>
			</ToolsModal>
		);
	}
}

export default QuickBooksRefreshModal;
